<template>
  <div class="main-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>

    <section class="heading-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}" v-if="!isLoading">
      <div class="heading-block">
        <div class="heading">
          {{ $t('message.mainPage.heading.title') }}
        </div>
        <div class="heading-desc">
          <a class="heading-link" :href="require('../../public/static/registryInclude.pdf')" target="_blank">
            {{ $t('message.mainPage.heading.desc.link') }}
          </a>
          {{ $t('message.mainPage.heading.desc.textStart') }}
          <br>
          {{ $t('message.mainPage.heading.desc.textEnd') }}
          <br>
          {{ $t('message.mainPage.heading.desc.textNotice') }}
        </div>
        <div class="heading-btn-block">
          <base-button
            :text="$t('message.mainPage.heading.btn')"
            @click="signUp()"
            v-if="!isAuthorized"
          />
        </div>
      </div>
      <img class="heading-img" src="../../public/custom/images/main-page/heading-img.png" alt="Heading-img">
    </section>

    <section class="offers-container" v-if="!isLoading">
      <div class="offers-title">{{ $t('message.mainPage.offers.title') }}</div>
      <div class="offers-block">
        <div class="title-item">
          <div class="offer-img"></div>
          <div class="offer-item-name"></div>
          <div class="offer-item-amount">{{ $t('message.mainPage.offers.tableTitle.amount') }}</div>
          <div class="offer-item-return">{{ $t('message.mainPage.offers.tableTitle.return') }}</div>
          <div class="offer-issued-by">{{ $t('message.mainPage.offers.tableTitle.issuedBy') }}</div>
          <div class="offer-rating">{{ $t('message.mainPage.offers.tableTitle.rating') }}</div>
          <div class="offer-btn-block"></div>
        </div>
        <div class="title-item">
          <div class="offer-img"></div>
          <div class="offer-item-name"></div>
          <div class="offer-item-amount">{{ $t('message.mainPage.offers.tableTitle.amount') }}</div>
          <div class="offer-item-return">{{ $t('message.mainPage.offers.tableTitle.return') }}</div>
          <div class="offer-issued-by">{{ $t('message.mainPage.offers.tableTitle.issuedBy') }}</div>
          <div class="offer-rating">{{ $t('message.mainPage.offers.tableTitle.rating') }}</div>
          <div class="offer-btn-block"></div>
        </div>
        <offer-item
          v-for="item of fullOffersList"
          :key="item.id"
          :item="item"
          :profile="profile"
        />
      </div>
      <div class="more-offers-block" v-if="isHasMoreOffers">
        <div class="more-offers-block-btn-block">
          <base-button
            :text="$t('message.mainPage.offers.more')"
            @click="updateOffersList()"
          />
        </div> 
      </div>
    </section>

    <section class="hiw-container" v-if="!isLoading">
      <div class="hiw-block">
        <div class="hiw-data">
          <div class="hiw-data-title">{{ $t('message.mainPage.hiw.title') }}</div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">1</div>
              <span>{{ $t('message.mainPage.hiw.first.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.first.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">2</div>
              <span>{{ $t('message.mainPage.hiw.second.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.second.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">3</div>
              <span>{{ $t('message.mainPage.hiw.third.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.third.desc') }}
            </div>
          </div>
        </div>
        <img class="hiw-image" src="../../public/custom/images/main-page/hiw-image.png" alt="Men image">
      </div>
    </section>

    <section class="advantages-container" v-if="!isLoading">
      <div class="advantages-title">{{ $t('message.mainPage.advantages.title') }}</div>
      <div class="advantages-block">
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/Bank.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.first') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/time.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.second') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/7.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.third') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/ssl.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.fourth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/rating.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.fifth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/judge.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.sixth') }}</div>
        </div>
      </div>
    </section>

    <!-- <section class="loans">
      <section class="target-loans-container">
        <div class="target-loans-title">
          {{ $t('message.mainPage.targetLoans.title') }}
        </div>
        <div class="target-loans-block">
          <div class="targets-loan-item" v-for="item of targetLoansList" :key="item.title">
            <img class="target-loans-img" :src="require(`../../public/custom/images/main-page/target-loans/${item.img}.svg`)" alt="Target loans image">
            <div class="targets-loan-item-title">
              {{ $t(`message.mainPage.targetLoans.${item.title}`) }}
            </div>
            <div class="targets-loan-item-data">
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.amount') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.first }} BYN</span>
              </div>
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.time') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.second }} {{ $t('message.mainPage.targetLoans.days') }}</span>
              </div>
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.amount') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.third }} BYN</span>
              </div>
            </div>
            <div class="targets-loan-item-btn-block">
              <base-button
                :text="$t('message.mainPage.targetLoans.btn')"
              />
            </div>
          </div>
        </div>
      </section>
      <section class="new-loan-container">
        <div class="new-loan-block">
          <div class="new-loan-title">{{ $t('message.mainPage.newLoan.title') }}</div>
          <div class="new-loan-desc">{{ $t('message.mainPage.newLoan.descFirstRow') }}</div>
          <div class="new-loan-desc">{{ $t('message.mainPage.newLoan.descSecondRow') }}</div>
        </div>
        <img class="new-loan-img" src="../../public/custom/images/main-page/new-loan-image.png" alt="New loan image">
      </section>
    </section> -->

    <section class="partners-container" v-if="!isLoading">
      <div class="partners-title">{{ $t('message.mainPage.partners.title') }}</div>
      <div class="bottom-partners-block">
        <img src="../../public/custom/images/main-page/partners/national-bank.png" alt="National bank image">
        <img src="../../public/custom/images/main-page/partners/paritet.png" alt="Paritet image">
        <!-- <img src="../../public/custom/images/main-page/partners/bpc.png" alt="Bpc image"> -->
        <img src="../../public/custom/images/main-page/partners/msi.png" alt="Msi image">
        <img src="../../public/custom/images/main-page/partners/elportal.png" alt="Electronic portal image">
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/base/BaseButton.vue';
import { mapGetters } from 'vuex';
import offerItem from './Main/offerItem.vue';
import StaticPagesHeader from '../components/common/StaticPagesHeader.vue';

export default {
  name: 'Main',
  inject: ['$httpService'],
  components: {
    BaseButton,
    offerItem,
    StaticPagesHeader
  },
  async created() {
    await this.$store.dispatch('getOffersList', 'published');
    this.fullOffersList = [...this.offersList];
    this.isLoading = false;
  },
  data() {
    return {
      page: 0,
      fullOffersList: [],
      targetLoansList: [
        {
          title: 'first',
          numbers: {
            first: 100,
            second: 7,
            third: 125
          },
          img: 'pig'
        },
        {
          title: 'second',
          numbers: {
            first: 250,
            second: 10,
            third: 300
          },
          img: 'calendar'
        },
        {
          title: 'third',
          numbers: {
            first: 300,
            second: 30,
            third: 400
          },
          img: 'universal'
        },
        {
          title: 'fourth',
          numbers: {
            first: 700,
            second: 14,
            third: 850
          },
          img: 'bags'
        },
        {
          title: 'fifth',
          numbers: {
            first: 450,
            second: 21,
            third: 550
          },
          img: 'repair'
        },
        {
          title: 'sixth',
          numbers: {
            first: 750,
            second: 45,
            third: 1000
          },
          img: 'vocations'
        }
      ],
      isLoading: true,
      isMobileMenuOpen: false,
      isOfferBtnLoading: false
    }
  },
  methods: {
    signUp() {
      this.$router.push({ name: 'msi' });
    },
    async signOut() {
      await localStorage.removeItem('token');
      await this.$store.dispatch('purgeProfile');
    },
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    async updateOffersList() {
      this.page = ++this.page;
      await this.$store.dispatch('updateOffersList', {status: 'published', page: this.page});
      this.fullOffersList = [...this.fullOffersList, ...this.offersList];
    }
  },
  computed: {
    ...mapGetters(['profile', 'offersList', 'isHasMoreOffers']),
    isAuthorized() {
      return this.profile?.role;
    },
    parsedUserName() {
      if (this.isAuthorized) {
        return this.profile.name_ru?.given_name_ru.slice(0, 1) + this.profile.name_ru?.family_name_ru.slice(0, 1);
      } else {
        return '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-page-wrapper {
    @include base-page-wrapper;
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: white;
  }

  .header-menu-open {
    position: fixed;
    top: 0;
    left: 0;
  }

  .header-container {
    @include base-page-container;

    margin-bottom: 11px;
    height: 74px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .heading-container-mobile-menu-open {
    margin-top: 85px;
  }

  .mobile-menu-container {
    position: fixed;
    height: 100vh;
    width: calc(100vw);
    padding-top: 40px;
    padding-left: 10px;
    box-sizing: border-box;
    top: 74px;
    left: calc(100vw + 700px);
    display: flex;
    flex-direction: column;
    background-color: #F8F8F8;
    transition: left .2s ease-in-out;
    z-index: 1000;
  }

  .mobile-nav-block {
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;

    .nav-item {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 16px;
      line-height: 135%;
      color: #121212;
    }
  }

  .mobile-authorization-block {
    display: flex;
    flex-direction: column;

    .sign-in-block,
    .sign-out-block {
      margin-left: 0;
      margin-bottom: 25px;
    }

    .reg-btn {
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
    }
  }

  .mobile-menu-container-open {
    left: 0;
  }

  .bottom-line {
    @include base-page-container;

    max-width: 100%;
    height: 2px;
    border-radius: 3px;
    background-color: #ECEEF0;
  }

  .header-block {
    @include base-page-container;

    height: 100%;
    max-width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .nav-block {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .logo {
    margin-right: 55px;
  }

  .nav {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .nav-item {
    padding-right: calc(20px + 12 * (100vw / 1920));
    font-weight: 600;
    font-size: calc(14px + 4 * (100vw / 1920));
    line-height: 25px;
    color: #121212;
    cursor: pointer;
  }

  .authorization-block {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .profile-img {
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F49332;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: white;
    border-radius: 50%;
    cursor: pointer;
  }

  .sign-in-block,
  .sign-out-block {
    margin-left: 20px;
    width: 104px;
    height: 38px;
  }

  .mobile-menu-open-img {
    display: none;
  }

  .heading-container {
    width: 100%;
    margin-bottom: 75px;
    padding: 0px 95px 0px 140px;
    box-sizing: border-box;
    background-color: #FDFAF1;
    display: flex;
    justify-content: space-between;
  }

  .heading-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .heading {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: calc(20px + 30 * (100vw / 1920));
    line-height: calc(24px + 37 * (100vw / 1920));
    color: #121212;
  }

  .heading-desc {
    margin-bottom: 60px;
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #3D3F42;
  }

  .heading-link {
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #41BF7B;
    text-decoration: none;
  }

  .heading-btn-block {
    width: 300px;
    height: 65px;
  }

  .heading-img {
    max-width: 60%;
    max-height: 500px;
    margin-right: 15%;
  }

  .hiw-container,
  .target-loans-container {
    @include base-page-container;

    padding: 0 202px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }

  .offers-container {
    @include base-page-container;

    margin-bottom: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .offers-block {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 60px;
  }

  .more-offers-block {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .more-offers-block-btn-block {
    width: 275px;
    max-width: 95%;
    height: 60px;
  }

  .offer-item,
  .title-item {
    padding-bottom: 13px;
    box-sizing: border-box;
    height: 62px;
    width: calc(50% - 30px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom:  1px solid #ECEEF0;
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #121212;
  }

  .title-item {
    border: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #878787;
  }

  .offer-img {
    height: 30px;
    width: 30px;
    margin-right: 8px;
  }

  .offer-item-name {
    @include overflow-elipsis;

    width: 20%;
    margin-right: 4px;
  }

  .offer-item-amount {
    width: 13%;
    margin-right: 4px;
  }

  .offer-item-return {
    width: 15%;
    margin-right: 4px;
  }

  .offer-issued-by {
    width: 12%;
    margin-right: 4px;
  }

  .offer-rating {
    width: 13%;
    margin-right: 4px;
  }

  .offer-btn-block {
    width: 170px;
    height: 36px;
  }

  .offer-btn ::v-deep {
    padding: 0;
    box-sizing: border-box;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #41BF7B;
    background-color: white;
    border: 2px solid #41BF7B;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #41BF7B;
      color: white;
    }
  }

  .offer-btn-loading ::v-deep {
    &:hover {
      color: #41BF7B;
    background-color: white;
    }
  }

  .mobile-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #878787;
    white-space: nowrap;
  }

  .offer-name-block-mobile {
    width: 100%;
    margin-bottom: 10px;
    margin-top: 15px;
    display: none;
    align-items: center;

    .offer-img {
      display: block;
    }

    .offer-item-name {
      display: block;
      width: inherit;
    }
  }

  .offer-amount-block-mobile,
  .offer-return-block-mobile,
  .offer-issued-block-mobile,
  .offer-rating-block-mobile {
    width: 100%;
    margin-bottom: 8px;
    display: none;
    justify-content: space-between;
    align-items: flex-end;
  }

  .offer-amount-block-mobile {
    .offer-item-amount {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-return-block-mobile {
    .offer-item-return {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-issued-block-mobile {
    .offer-issued-by {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-rating-block-mobile {
    margin-bottom: 15px;
    .offer-rating {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-btn-block-mobile {
    height: 50px;
    width: 100%;
    display: none;
  }

  .hiw-block {
    width: 100%;
    max-height: 550px;
    margin-bottom: 140px;
    display: flex;
    justify-content: space-between;
  }

  .hiw-data {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .hiw-item {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .hiw-image {
    height: 525px;
  }

  .hiw-item-number {
    height: 37px;
    width: 37px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #41BF7B;
    color: white;
  }

  .hiw-item-title {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: calc(20px + 6 * (100vw / 1920));
    line-height: 35px;
    color: #121212;
  }

  .hiw-desc {
    margin-left: 57px;
    font-weight: 400;
    font-size: calc(16px + 2 * (100vw / 1920));
    line-height: 135%;
    color: #474747;
  }

  .loans {
    width: 100%;
    padding-top: 70px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F8F8F8;;
  }

  .target-loans-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .target-loans-block {
    width: 100%;
    margin-bottom: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .targets-loan-item {
    width: 398px;
    height: 460px;
    padding-top: 40px;
    margin-bottom: 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    box-shadow: 2px 2px 30px rgba(177, 179, 182, 0.2);
    border-radius: 20px;
    background-color: white;
  }

  .target-loans-img {
    position: absolute;
    top: 110px;
    left: 49px;
    z-index: 1;
  }

  .targets-loan-item-title {
    margin-bottom: 41px;
    font-weight: 500;
    font-size: 32px;
    line-height: 39px;
    letter-spacing: 0.01em;
    color: #121212;
  }

  .targets-loan-item-data {
    margin-bottom: 132px;
    width: 202px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
  }

  .loan-data-item {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    line-height: 130%;
    color: #878787;

    .loan-data-item-number {
      color: #474747;
      font-weight: 600;
    }
  }

  .targets-loan-item-btn-block {
    width: 250px;
    height: 60px;
    position: relative;
    z-index: 2;
  }

  .new-loan-container {
    @include base-page-container;

    margin-bottom: 70px;
    padding-left: 146px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(180deg, #FFDED8 0%, #FFDCD8 51.14%, #FFDCD8 100%);
    border-radius: 20px;
  }

  .new-loan-block {
    display: flex;
    flex-direction: column;
  }

  .new-loan-title {
    margin-bottom: 25px;
    text-align: start !important;
  }

  .new-loan-desc {
    font-weight: 400;
    font-size: 22px;
    line-height: 130%;
    color: #474747;
  }

  .new-loan-desc:last-child {
    margin-bottom: 60px;
  }

  .new-loan-img {
    border-radius: 20px;
  }

  .advantages-container {
    @include base-page-container;

    margin-bottom: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .offers-title,
  .advantages-title,
  .partners-title,
  .hiw-data-title,
  .target-loans-title,
  .new-loan-title {
    font-weight: 700;
    font-size: calc(24px + 16 * (100vw / 1920));;
    line-height: 125%;
    color: #121212;
    text-align: center;
  }

  .hiw-data-title {
    text-align: start;
  }

  .advantages-title,
  .target-loans-title,
  .offers-title {
    margin-bottom: 50px;
  }

  .offers-title {
    text-align: center;
  }

  .advantages-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .advantages-item {
    width: 272px;
    height: 250px;
    padding: 30px 34px 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 2px 30px rgba(177, 179, 182, 0.2);
    border-radius: 20px;
  }

  .advantages-item-img-block {
    width: 68px;
    height: 68px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .advantages-item-desc {
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #474747;
  }

  .partners-container {
    @include base-page-container;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .partners-title {
    margin-bottom: 54px;
  }

  .partners-block {
    width: 100%;
    margin-bottom: 70px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .partner-img {
    max-width: 550px;
    max-height: 340px;
    width: 32%;
    border-radius: 20px;
  }

  .bottom-partners-block {
    width: 100%;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    img {
      margin-bottom: 20px;
    }
  }

  .reg-btn {
    font-weight: 600;
    font-size: calc(14px + 4 * (100vw / 1920));
    line-height: 25px;
    color: #41BF7B;
    cursor: pointer;
  }

  @media screen and (max-width: 1610px) {
    .hiw-container,
    .target-loans-container {
      padding: 0 5%;
    } 
  }

  @media screen and (max-width: 1770px) {
    .advantages-container,
    .partners-container {
      width: 1400px;
    }

    .advantages-item {
      width: 205px;
      height: 200px;
      padding: 20px 24px 0 20px;
    }

    .advantages-item-img-block {
      width: 50px;
      height: 50px;

      img {
        width: 50px;
        height: 50px;
      }
    }

    .advantages-item-desc {
      font-size: 15px;
    }

    .bottom-partners-block {
      img {
        width: 249px;
      }
    }
  }

  @media screen and (max-width: 1750px) {
    .advantages-container {
      margin-bottom: 110px;
    }
    .advantages-block {
      justify-content: space-evenly;
    }
    .advantages-item {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 1530px) {
    .heading-desc {
      br {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1450px) {
    .heading-container {
      padding: 0px 2.5% 0px 2.5%;
    }

    .heading-img {
      max-height: 450px;
      margin-right: 10%;
    }
  }

  @media screen and (max-width: 1320px) {
    .advantages-block {
      justify-content: space-evenly;
    }
  }

  @media screen and (max-width: 1300px) {
    .heading-img {
      margin-right: 0;
    }

    .hiw-container {
      padding: 0;
    }

    .hiw-image {
      object-fit: contain;
      height: 480px;
    }

    .hiw-data-title {
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 1250px) {

    .title-item {
      display: none;
    }
    .offer-item {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
    }

    .offer-img,
    .offer-item-name,
    .offer-item-amount,
    .offer-item-return,
    .offer-issued-by,
    .offer-rating,
    .offer-btn-block {
      display: none;
    } 

    .offer-name-block-mobile,
    .offer-amount-block-mobile,
    .offer-return-block-mobile,
    .offer-issued-block-mobile,
    .offer-rating-block-mobile {
      display: flex;
    }

    .offer-btn-block-mobile {
      display: block;
    }
  }

  @media screen and (max-width: 1150px) {
    .nav {
      display: none;
    }

    .authorization-block {
      display: none;
    }

    .mobile-menu-open-img {
      display: block;
      cursor: pointer;
    } 
  }

  @media screen and (max-width: 1060px) {
    .hiw-image {
      height: 270px;
    }
  }

  @media screen and (max-width: 890px) {
    .heading-container {
      padding-top: 70px;
      padding-bottom: 30px;
      flex-direction: column;
      align-items: center;
    }

    .heading-block {
      align-items: center;
      margin-bottom: 40px;
    }

    .heading {
      text-align: center;
    }

    .hiw-block {
      max-height: fit-content;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .hiw-data {
      width: 100%;
      margin-bottom: 40px;
    }

    .hiw-data-title {
      margin-bottom: 30px;
    }

    .hiw-item {
      margin-bottom: 25px;
    }

    .hiw-item-title {
      flex-direction: column;
      align-items: flex-start;

      span {
        margin-bottom: 8px;
      }
    }

    .hiw-item-number {
      margin-bottom: 10px;
    }

    .hiw-desc {
      margin-left: 0;
    }

    .hiw-image {
      width: 90%;
      height: auto;
    }
  }

  @media screen and (max-width: 790px) {
    .partners-block {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .partner-img {
      width: 100%;
      margin-bottom: 30px;
    }

    .paritet {
      order: 1;
    }

    .national-bank {
      order: 2;
    }

    .msi {
      order: 5;
    }

    .htp {
      order: 6;
    }

    .elportal {
      order: 3;
    }

    .bpc {
      order: 4;
    }

    .bottom-partners-block {
      img {
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 670px) {
    .heading {
      text-align: left;
    }
    .advantages-block {
      justify-content: space-between;
    }

    .advantages-item {
      height: 226px;
      width: calc(50% - 5px);
      padding: 30px 15px 0 15px;
    }

    .advantages-item-desc {
      font-size: 14px;
      line-height: 125%;
    }

    .bottom-partners-block {
      justify-content: center;
    }
  }

  @media screen and (max-width: 600px) {
    .offers-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .offer-item {
      width: 100%;
    }
  }
</style>